module.exports = __webpack_public_path__ + "img/1437.ce121ce9.gif";